"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeThroughoutPlaceLiveWords = void 0;
exports.placeAloneProposalOf = placeAloneProposalOf;
var _react = _interopRequireWildcard(require("react"));
var _changeThroughoutSelection = require("@common/utils/redline/change-throughout-selection");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _useLiveProposal = require("../../../hooks/use-live-proposal");
var _useProposalEngineEnabled = require("../../../hooks/use-proposal-engine-enabled");
var _cardLiveProposal = require("./card-live-proposal");
var _CardLiveChange = require("./CardLiveChange");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function placeAloneProposalOf(card, place) {
  var placeAlone = (0, _changeThroughoutSelection.changeThroughoutProposalOf)(card, new Set([place.match_id]));
  if (placeAlone.changedMatches.length === 0) return null;
  return _objectSpread(_objectSpread({}, placeAlone.proposal), {}, {
    paragraphs: placeAlone.proposal.paragraphs.filter(function (cardParagraph) {
      return cardParagraph.bookmark === place.paragraph_id;
    })
  });
}
function placeAlonePreviewOf(card, place) {
  var textRedline = placeAloneProposalOf(card, place);
  if (textRedline === null) return null;
  return (0, _cardLiveProposal.cardLivePreviewOf)({
    markup: "",
    textRedline: textRedline,
    bookmarks: [place.paragraph_id],
    afterBookmarks: [],
    edit: null
  });
}
var ChangeThroughoutPlaceLiveWords = exports.ChangeThroughoutPlaceLiveWords = function ChangeThroughoutPlaceLiveWords(_ref) {
  var _engineAccess$authorN;
  var card = _ref.card,
    place = _ref.place,
    placeIsApplied = _ref.placeIsApplied,
    wordsWhenProposed = _ref.wordsWhenProposed;
  var registry = (0, _useLiveProposal.useLiveProposalRegistry)();
  var engineAccess = (0, _useProposalEngineEnabled.useProposalEngineAccess)();
  var signedInAuthorName = engineAccess.signedIn ? (_engineAccess$authorN = engineAccess.authorName) !== null && _engineAccess$authorN !== void 0 ? _engineAccess$authorN : _redlineEngine.DIOPTRA_AUTHOR : null;
  var preview = (0, _react.useMemo)(function () {
    return placeAlonePreviewOf(card, place);
  }, [card, place]);
  var request = preview === null ? null : (0, _cardLiveProposal.liveProposalRequestOf)(preview, signedInAuthorName);
  if (preview === null || request === null) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: wordsWhenProposed
  });
  if (placeIsApplied && registry.appliedLookOf(request) === null) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: wordsWhenProposed
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardLiveChange.CardLiveChange, {
    preview: preview,
    signedInAuthorName: signedInAuthorName,
    blockLimit: _cardLiveProposal.CARD_EXCERPT_BLOCK_LIMIT,
    applied: placeIsApplied,
    "data-sentry-element": "CardLiveChange",
    "data-sentry-component": "ChangeThroughoutPlaceLiveWords",
    "data-sentry-source-file": "ChangeThroughoutPlaceLiveWords.tsx"
  });
};